export default __webpack_public_path__ + "static/media/MTcarpaEspecial_Frente.805f58fc.webp";